import React from 'react';
import { JsonForms, JsonFormsInitStateProps, JsonFormsReactProps } from '@jsonforms/react';
import { renderers } from './renderers';

interface DynamicFormFrameProps extends Partial<JsonFormsInitStateProps & JsonFormsReactProps> {}

export function DynamicFormFrame(props: DynamicFormFrameProps) {
  return <JsonForms {...props} data={props.data} renderers={[...(props.renderers ?? []), ...renderers]} />;
}
